import { type BillingServices } from '@/api/services/billing';
import { type ResolveUserAccountContext } from '@/router/resolvers/user';

export const resolveBillingParentAccountId = async (
  context: {
    getBillingAccountParentQuery: ReturnType<typeof BillingServices.getBillingAccountParentQuery>;
  } & ResolveUserAccountContext,
): Promise<string> => {
  const data = await context.queryClient.fetchQuery(context.getBillingAccountParentQuery);
  return data.parentAccountId;
};
